// Accessible accordion behavior
function faq_taggol(root = document) {
  const accordions = Array.from(root.querySelectorAll('[js-acc-item]'));

  const closeAccordion = (accordion) => {
    const trigger = accordion.querySelector('[js-acc-single-trigger]');
    const content = accordion.querySelector('[js-acc-single-content]');
    accordion.classList.remove('active');
    trigger?.setAttribute('aria-expanded', 'false');
    if (content) content.style.maxHeight = null;
  };

  const openAccordion = (accordion) => {
    const trigger = accordion.querySelector('[js-acc-single-trigger]');
    const content = accordion.querySelector('[js-acc-single-content]');
    accordion.classList.add('active');
    trigger?.setAttribute('aria-expanded', 'true');
    if (content) content.style.maxHeight = 'max-content';
  };

  accordions.forEach((accordion, index) => {
    const trigger = accordion.querySelector('[js-acc-single-trigger]');
    const content = accordion.querySelector('[js-acc-single-content]');
    if (!trigger || !content || trigger.dataset.accordionReady === 'true') return;

    trigger.dataset.accordionReady = 'true';
    const contentId = content.id || `AccordionContent-${index + 1}`;
    content.id = contentId;
    trigger.setAttribute('aria-controls', contentId);
    trigger.setAttribute('aria-expanded', accordion.classList.contains('active') ? 'true' : 'false');

    if (!['BUTTON', 'SUMMARY'].includes(trigger.tagName)) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
    }

    const toggle = () => {
      if (accordion.classList.contains('active') || content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach(closeAccordion);
        openAccordion(accordion);
      }
    };

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });
}

function installTechnicalQaFixes() {
  const styleId = 'growmaster-technical-qa-fixes';
  let style = document.getElementById(styleId);
  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    document.head.appendChild(style);
  }

  style.textContent = `
    body.template-search .facets__summary,
    body.template-search .facet-filters__field .select__select,
    body.template-search .mobile-facets__sort .select__select,
    body.template-search span.active-facets__button-inner,
    body.template-search .active-facets__button-wrapper .active-facets__button-remove {
      color: rgb(var(--color-foreground)) !important;
    }

    body.template-search .facet-filters__field .select .svg-wrapper svg path {
      fill: currentColor !important;
    }

    body.template-search .facet-filters__sort:focus-visible,
    body.template-search .mobile-facets__sort .select__select:focus-visible,
    .footer [js-acc-single-trigger]:focus-visible {
      outline: 2px solid currentColor !important;
      outline-offset: 4px !important;
      box-shadow: none !important;
    }

    .menu-drawer__grandchild-list {
      margin: 0;
      padding: 0 0 0.75rem 1.5rem;
    }

    .menu-drawer__menu-item--grandchild {
      font-size: 0.92em;
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
    }

    .footer [js-acc-single-trigger] {
      cursor: pointer;
    }

    @media screen and (max-width: 749px) {
      inbox-online-store-chat {
        max-width: 64px;
        max-height: 64px;
      }
    }
  `;

  document.querySelectorAll('a[href*="/pages/growbox-growzelt-mieten"]').forEach((link) => {
    link.setAttribute('href', '/collections/growbox-growzelt-mieten-komplettsets');
  });
}

(function initDynamicTheme() {
  faq_taggol();
  installTechnicalQaFixes();

  if (document.querySelector('[data-banner-header-overlay]')) {
    document.body.classList.add('header-overlay');
  }
})();

const productTabs = document.querySelectorAll('.product-tab-top ul li');
productTabs.forEach((tab) => {
  tab.addEventListener('click', function () {
    const title = this.getAttribute('data-title');
    productTabs.forEach((item) => item.classList.remove('active'));
    this.classList.add('active');
    document.querySelectorAll('.product-tab-content').forEach((content) => content.classList.remove('active'));
    document.querySelector(`.product-tab-content[data-content="${CSS.escape(title || '')}"]`)?.classList.add('active');
  });
});

function autosize() {
  document.querySelectorAll('.autosize').forEach((textarea) => {
    textarea.setAttribute('rows', 6);
    const resize = () => {
      textarea.style.height = '120px';
      textarea.style.height = `${textarea.scrollHeight}px`;
    };
    resize();
    textarea.addEventListener('input', resize);
  });
}
autosize();

function activateMegaMenuItem(rightItem) {
  const rightTitle = rightItem.getAttribute('data-title');
  const menuRightItems = document.querySelectorAll('.menu_right li.menu-title');
  const menuLeftItems = document.querySelectorAll('.menu_left [data-title]');
  const childImages = document.querySelectorAll('.child-menu_img-wrp');

  menuRightItems.forEach((item) => item.classList.toggle('active', item === rightItem));
  menuLeftItems.forEach((item) => item.classList.toggle('active', item.getAttribute('data-title') === rightTitle));
  childImages.forEach((image) => image.classList.toggle('active', image.getAttribute('data-img-title') === rightTitle));
  document.querySelectorAll('.grandchild-menu_img-wrp').forEach((image) => image.classList.remove('active'));
}

document.querySelectorAll('.menu_right li.menu-title').forEach((item) => {
  item.addEventListener('mouseenter', () => activateMegaMenuItem(item));
  item.addEventListener('focusin', () => activateMegaMenuItem(item));
});

function activateGrandchildImage(link) {
  const title = link.getAttribute('data-menu-grandchild-title');
  document.querySelectorAll('.grandchild-menu_img-wrp').forEach((image) => {
    image.classList.toggle('active', image.getAttribute('data-gimg-title') === title);
  });
  document.querySelectorAll('.child-menu_img-wrp').forEach((image) => image.classList.remove('active'));
}

document.querySelectorAll('.menu-grandchildlink[data-menu-grandchild-title]').forEach((link) => {
  link.addEventListener('mouseenter', () => activateGrandchildImage(link));
  link.addEventListener('focusin', () => activateGrandchildImage(link));
});

const faqTabs = Array.from(document.querySelectorAll('.tabs.custom-faq-tab ul li'));
const faqPanels = Array.from(document.querySelectorAll('.grid__item.tab-faq-section-inner .panel'));

function activateFaqTab(tab, moveFocus = false) {
  const targetId = (tab.getAttribute('data-href') || '').replace('#', '');
  faqTabs.forEach((item) => {
    const active = item === tab;
    item.classList.toggle('active', active);
    const control = item.querySelector('button, a');
    control?.setAttribute('aria-selected', String(active));
    control?.setAttribute('tabindex', active ? '0' : '-1');
  });
  faqPanels.forEach((panel) => {
    const active = panel.id === targetId;
    panel.classList.toggle('active', active);
    panel.hidden = !active;
  });
  if (moveFocus) tab.querySelector('button, a')?.focus();
}

faqTabs.forEach((tab, index) => {
  const control = tab.querySelector('button, a');
  const targetId = (tab.getAttribute('data-href') || '').replace('#', '');
  tab.setAttribute('role', 'presentation');
  control?.setAttribute('role', 'tab');
  control?.setAttribute('aria-controls', targetId);
  faqPanels.find((panel) => panel.id === targetId)?.setAttribute('role', 'tabpanel');

  tab.addEventListener('click', (event) => {
    event.preventDefault();
    activateFaqTab(tab);
  });

  control?.addEventListener('keydown', (event) => {
    if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % faqTabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + faqTabs.length) % faqTabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = faqTabs.length - 1;
    activateFaqTab(faqTabs[nextIndex], true);
  });
});

if (faqTabs.length) activateFaqTab(faqTabs.find((tab) => tab.classList.contains('active')) || faqTabs[0]);

let scrollTicking = false;
window.addEventListener(
  'scroll',
  () => {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(() => {
      document.querySelector('sticky-header')?.classList.toggle('active-sticky', window.scrollY > 10);
      scrollTicking = false;
    });
  },
  { passive: true }
);

const chatIconMarkup = `
<img
  id="chat-icon"
  src="https://cdn.shopify.com/s/files/1/0795/1332/1807/files/Ki_Bot_3-Photoroom.png?v=1779876488"
  alt="Chat öffnen"
  width="60"
  height="60"
  style="width:100%;height:100%;object-fit:contain;"
>`;

function replaceChatIcon() {
  const chat = document.querySelector('inbox-online-store-chat');
  const button = chat?.shadowRoot?.querySelector('button.chat-toggle');
  if (!button) return false;

  const compact = window.matchMedia('(max-width: 749px)').matches;
  const size = compact ? '64px' : '80px';
  button.style.height = size;
  button.style.width = size;
  button.style.borderRadius = '50%';
  button.setAttribute('aria-label', button.getAttribute('aria-label') || 'Chat öffnen');
  if (!button.querySelector('#chat-icon')) button.innerHTML = chatIconMarkup;
  return true;
}

(function initializeChatIcon() {
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (replaceChatIcon() || attempts >= 30) window.clearInterval(timer);
  }, 500);

  const observer = new MutationObserver(() => {
    if (replaceChatIcon()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 30000);
  window.addEventListener('resize', replaceChatIcon, { passive: true });
})();

function custom_deposite_add(timestamp) {
  const depositVariant = document.querySelector('.product-form__submit')?.getAttribute('data-deposit-variant');
  if (!depositVariant) return Promise.resolve(null);

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: depositVariant,
          quantity: 1,
          properties: { _timestamp: timestamp },
        },
      ],
    }),
  })
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Kaution konnte nicht hinzugefügt werden.');
      document.querySelector('cart-drawer')?.refresh?.(true);
      return data;
    })
    .catch((error) => {
      console.error('Deposit add failed:', error);
      document.dispatchEvent(new CustomEvent('growmaster:deposit-error', { detail: { message: error.message } }));
      throw error;
    });
}

function custom_updatecart_fun(updates, openDrawer) {
  return fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    body: updates,
    headers: { Accept: 'application/json' },
  })
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Warenkorb konnte nicht aktualisiert werden.');

      const cartDrawer = document.querySelector('cart-drawer');
      if (openDrawer && cartDrawer) {
        cartDrawer.refresh(true);
        window.setTimeout(() => cartDrawer.classList.toggle('is-empty', data.item_count === 0), 500);
      }
      return data;
    })
    .catch((error) => {
      console.error('Cart update failed:', error);
      throw error;
    });
}
